__turbopack_context__.v({
  "benA": "hOrfaa_benA",
  "benB": "hOrfaa_benB",
  "benH": "hOrfaa_benH",
  "benV": "hOrfaa_benV",
  "bit": "hOrfaa_bit",
  "bitGravitation": "hOrfaa_bitGravitation",
  "bitSnurr": "hOrfaa_bitSnurr",
  "bitUt": "hOrfaa_bitUt",
  "decimaler": "hOrfaa_decimaler",
  "fall": "hOrfaa_fall",
  "huvud": "hOrfaa_huvud",
  "klams": "hOrfaa_klams",
  "klatt": "hOrfaa_klatt",
  "kronblad": "hOrfaa_kronblad",
  "kryp": "hOrfaa_kryp",
  "kyckling": "hOrfaa_kyckling",
  "lager": "hOrfaa_lager",
  "partikel": "hOrfaa_partikel",
  "picka": "hOrfaa_picka",
  "prick": "hOrfaa_prick",
  "snurr": "hOrfaa_snurr",
  "snurra": "hOrfaa_snurra",
  "spindel": "hOrfaa_spindel",
  "steg": "hOrfaa_steg",
  "stig": "hOrfaa_stig",
  "svaj": "hOrfaa_svaj",
  "vagga": "hOrfaa_vagga",
  "varv": "hOrfaa_varv",
});
